import React from "react";

import { Form, Input, DatePicker } from "antd";
import { FormInstance } from "antd/lib/form";
import { Dayjs } from "dayjs";

interface InvoiceDatesAndRefProps {
  form: FormInstance;
}

export const InvoiceDatesAndRef: React.FC<InvoiceDatesAndRefProps> = ({
  form,
}) => {
  const issueDate: Dayjs = Form.useWatch("issueDate", form);
  const language = Form.useWatch("language", form);

  const texts = {
    issueDateLabel: language === "es" ? "Fecha de Emisión" : "Date of Issue",
    dueDateLabel: language === "es" ? "Fecha de Vencimiento" : "Due Date",
    referenceLabel: language === "es" ? "Referencia" : "Reference",
  };

  const disablePastDueDate = (current: Dayjs): boolean => {
    if (!issueDate) {
      return false;
    }
    return current.startOf("day").isBefore(issueDate.startOf("day"));
  };

  return (
    <>
      {/* Date of Issue */}
      <div>
        <div className="font-bold text-green-600 mb-1">
          {texts.issueDateLabel}
        </div>
        <Form.Item
          name="issueDate"
          className="mb-0"
          rules={[{ required: true, message: "Required" }]}
        >
          <DatePicker
            format="YYYY-MM-DD"
            className="w-full datepicker-align-right"
            allowClear={false}
          />
        </Form.Item>
      </div>

      {/* Due Date */}
      <div>
        <div className="font-bold text-green-600 mb-1">
          {texts.dueDateLabel}
        </div>
        <Form.Item
          name="dueDate"
          className="mb-0"
          rules={[{ required: true, message: "Required" }]}
        >
          <DatePicker
            format="YYYY-MM-DD"
            className="w-full datepicker-align-right"
            disabledDate={disablePastDueDate}
            allowClear={false}
          />
        </Form.Item>
        {Form.useWatch("issueDate", form) && null}
      </div>

      {/* Reference */}
      <div>
        <div className="font-bold text-green-600 mb-1">
          {texts.referenceLabel}
        </div>
        <Form.Item name="reference" className="mb-0">
          <Input placeholder="P.O. Number or Project Ref." />
        </Form.Item>
      </div>
    </>
  );
};
